export class LevelMap {
  constructor(scene, data) {
    this._scene = scene;
    this._data = data;
    this._mapdata = this._createBlankMapData();
    this._mapdata.skyColour = data.backgroundcolor;
    data.layers.forEach((layer, i) => {
      if (layer.type === 'objectgroup') this._parseObjectLayer(layer, this._mapdata);
      if (layer.type === 'tilelayer')
        this._parseTileLayer(
          layer,
          this._mapdata,
          i > data.layers.findIndex((l) => l.name === 'world')
        );
    });
  }

  get mapWidth() {
    return this._data.width * this._data.tilewidth;
  }

  get mapHeight() {
    return this._data.height * this._data.tileheight;
  }

  getMapData() {
    return JSON.parse(JSON.stringify(this._mapdata));
  }

  get heroSpawn() {
    return { ...this._mapdata.heroSpawn };
  }

  get combatzones() {
    return [...this._mapdata.combatzones];
  }

  get enemySpawns() {
    return [...this._mapdata.enemySpawns];
  }

  get exit() {
    return this._mapdata.exit;
  }

  _createBlankMapData() {
    return {
      exit: false,
      heroSpawn: false,
      objects: [],
      combatzones: [],
      enemySpawns: [],
      foregroundLayers: [],
      backgroundLayers: [],
    };
  }

  _parseTileLayer(data, output, overworld) {
    const tiles = [];
    data.data.forEach((tile, i) => {
      const tileconfig = this._gidToTile(tile);
      if (tileconfig) {
        const x = (i % this._data.width) * this._data.tilewidth;
        const y = Math.floor(i / this._data.width) * this._data.tileheight + this._data.tileheight;
        tiles.push({ x, y, ...tileconfig });
      }
    });
    const props =
      data.properties?.reduce((o, p) => {
        o[p.name] = p.value;
        return o;
      }, {}) || {};

    let scrollspeed = false;
    if (props.scrollSpeed) {
      const split = props.scrollSpeed.split(',');
      scrollspeed = {};
      scrollspeed.x = parseFloat(split[0]);
      scrollspeed.y = split.length > 1 ? parseFloat(split[1]) : scrollspeed.x;
    }

    if (overworld) {
      output.foregroundLayers.push({ tiles, scrollspeed });
    } else {
      output.backgroundLayers.push({ tiles, scrollspeed });
    }
  }

  _parseObjectLayer(data, output = { colliders }) {
    data.objects.forEach((object) => {
      switch (object.type) {
        case 'herospawn':
          output.heroSpawn = { x: object.x, y: object.y };
          break;
        case 'exit':
          output.exit = object.x + object.width;
          output.objects.push({
            name: object.name,
            type: object.type,
            x: object.gid ? Math.round(object.x + object.width * 0.5) : Math.round(object.x),
            y: Math.round(object.y),
            width: Math.round(object.width),
            height: Math.round(object.height),
            ...this._gidToTile(object.gid),
            ...this._parseObjectGroupProperties(object),
          });
          break;
        case 'enemy':
        case 'enemyspawn':
          output.enemySpawns.push({ x: object.x, y: object.y, type: object.name });
          break;
        case 'combatzone':
          output.combatzones.push({
            x: object.x,
            y: object.y,
            width: object.width,
            height: object.height,
            name: object.name,
            type: object.type,
            ...this._parseObjectGroupProperties(object),
          });
          break;
        default:
          output.objects.push({
            name: object.name,
            type: object.type,
            x: object.gid ? Math.round(object.x + object.width * 0.5) : Math.round(object.x),
            y: Math.round(object.y),
            width: Math.round(object.width),
            height: Math.round(object.height),
            ...this._gidToTile(object.gid),
            ...this._parseObjectGroupProperties(object),
          });
          break;
      }
    });
  }

  _gidToTile(gid) {
    if (!this._tilemap) {
      this._tilemap = {};

      for (let i = 0; i < this._data.tilesets.length; i++) {
        const tileset = this._data.tilesets[i];
        for (let t = 0; t < tileset.tiles.length; t++) {
          const tile = tileset.tiles[t];
          const gid = tile.id + tileset.firstgid;
          this._tilemap[gid] = {
            gid: gid,
            sprite: {
              sheet: tileset.name,
              frame: tile.image.substring(tile.image.lastIndexOf('/') + 1).replace('.png', ''),
            },
            ...this._parseObjectGroupProperties(tile),
          };
        }
      }
    }
    return this._tilemap[gid];
  }

  _parseObjectGroupProperties(object) {
    if (!object.objectgroup && !object.properties) return {};
    const results = {};
    object.objectgroup?.objects.forEach((entry) => {
      switch (entry.type) {
        case 'collider':
          results.collider = new Phaser.Geom.Rectangle(entry.x, entry.y, entry.width, entry.height);
          break;
        case 'damagebox':
          results.damagebox = new Phaser.Geom.Rectangle(
            entry.x,
            entry.y,
            entry.width,
            entry.height
          );
          break;
      }
    });
    object.properties?.forEach((entry) => {
      results[entry.name] = entry.value;
    });
    return results;
  }
}
